import { useState, useEffect } from 'react';
import type PermittedAdmin from '../models/permitted-admin';
import { getAllAdminsByOfficeId } from '../services/admins.services';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface InitialAdminState {
  readonly initialized: boolean;
  readonly error?: boolean;
}

interface AdminsState extends InitialAdminState {
  readonly admins?: PermittedAdmin[];
}

interface Props {
  readonly id: string | undefined;
}

const useAdmins = ({ id }: Props): AdminsState => {
  const [state, setState] = useState<AdminsState>({
    initialized: false,
  });
  const keycloak = useKeycloak();

  useEffect(() => {
    const getAdmins = async (): Promise<void> => {
      try {
        if (!id || id === '') {
          return;
        }

        const admins = (await getAllAdminsByOfficeId(id, keycloak)) ?? [];
        setState({ initialized: true, admins });
      } catch (error) {
        setState({ initialized: false, error: true });
      }
    };

    if (!state.initialized) {
      getAdmins();
    }
  }, [setState, state.initialized, keycloak, id]);

  return state;
};

export default useAdmins;
